import {React,useState,useEffect }from 'react'
import Breadcrumbs from '../../components/Common/Breadcrumb'
import Table from 'react-bootstrap/Table';
import { Button, Modal, ModalHeader } from 'reactstrap';
import Form from 'react-bootstrap/Form';
import 'bootstrap/dist/css/bootstrap.min.css';
import {ToastContainer,toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Axios from 'axios'

export default function Users() {
    const[email, setEmail] = useState("");
    const[storeID, setStoreid] = useState('');
    const[users, setUsers] = useState([]);
    const [modal, setModal] = useState(false);
    const [modal2, setModal2] = useState(false)
    const [username, setUsername] = useState('');
    const [firstname, setFirstname] = useState('');
    const [middlename, setMiddlename] = useState('')
    const [lastname, setLastname] = useState('');
    const [useremail,setUseremail] = useState('');
    const [phone, setPhone] = useState('');
    const [role, setRole] = useState('');
    const[branches, setBranches] = useState([]);
    const [branch, setBranch] = useState('');
    const [thisUsername, setThisusername] = useState('');
    const [thisFirstname, setThisfirstname] = useState('');
    const [thisMiddlename, setThismiddlename] = useState('');
    const [thisLastname, setThislastname] = useState('');
    const [thisEmail, setThisemail] = useState('');
    const [thisPhone, setThisphone] = useState('');
    const [thisRole, setThisrole] = useState('');
    const [thisBranch, setThisbranch] = useState('');
    const [selectedUser, setSelecteduser] = useState('');
    const [userrole, setUserrole] = useState('')

    useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await fetch('https://easyboxstoresapi.uuidesign.xyz/api/profile', {
          credentials: 'include', // to send cookies
        });
        const data = await res.json();

        if (data.valid) {
          setEmail(data.email)
        } else {}
      } catch (error) {} 
    };

    fetchProfile();
  }, []);

  //get store id
  useEffect(()=>{
   const fetchData = async()=>{
      try{
        const res = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/getUserdetails?email=${email}`);
        const data = await res.json();
        setStoreid(data.store_id)
        setUserrole(data.role)
      }
      catch(err){}
   }

   if(email){
    fetchData();
   }
   
  },[email])


  useEffect(()=>{
    const fetchData =async()=>{
        const res = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/getUsers?storeID=${storeID}`);
        const data = await res.json();
        setUsers(data)
    }

    if(storeID){
        fetchData();
    }
  },[storeID])

  useEffect(()=>{
    const fetchData =async()=>{
        const res = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/getBranches?storeID=${storeID}`);
        const data = await res.json();
        setBranches(data)
    }

    if(storeID){
        fetchData();
    }
  },[storeID])

  const fetchBranches =async()=>{
        const res = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/getUsers?storeID=${storeID}`);
        const data = await res.json();
        setUsers(data)
    }

    const toggle =()=>{

        if(userrole !== 'Admin' && userrole !== 'Manager'){
            toast.error('You do not have rights to perform this action')
          }

        else{
            setModal(!modal)
        }
        
    }

    const notification=()=>{
        const formattedPhone = phone.replace(/^0/, '254');
        Axios.post('https://n8n.uidevlabs.com/webhook/f05996a9-59bd-45e5-9404-949b0dce83f5',{
            username,formattedPhone,useremail,branch,storeID
        }).then((res)=>{
            toast.success('Notification sent')
        }).catch((err)=>{
            toast.error('Notification not sent')
        })
    }

    const submitUser =async()=>{
        if(userrole == 'Admin'){
            if(username !=='' && firstname !== '' && middlename !== '' && lastname !=='' && useremail !== '' && phone !== '' && role !== '' && branch !== ''){
                const res = await fetch('https://easyboxstoresapi.uuidesign.xyz/api/Submituser',{
                method:"POST",
                headers:{
                    "Content-Type":"application/json"
                },
                body:JSON.stringify({
                    username,firstname,middlename,lastname,useremail,phone,role,password:"123456",color:'#0000ff',branch,storeID
                }),
                credentials:'include'
            })
    
            const data = await res.json();
            const {success} = data;
            if(success == true){
                notification();
                toast.success('User has been added');
                fetchBranches();
                setFirstname('')
                setUseremail('');
                setUsername('');
                setMiddlename('');
                setLastname('');
                setRole('');
                setPhone('');
                setBranch('')
                setModal(false)
            }
            if(success == 'NE'){
                toast.error('The username already exists')
            }
            if(success == 'EE'){
                toast.error('The email already exists')
            }
            }
            else{
                toast.error('All fields are required')
            }

        }
        else{
            toast.error('You do not have permission to perform this action')
        }
        
       
        
    }

    const toggle2 =async(e)=>{
        if(userrole !== 'Admin' && userrole !== 'Manager'){
            toast.error('You do not have rights to perform this action')
          }
        else{
            const id = e.target.value;
            setSelecteduser(id)
            const res = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/getThisuser?id=${id}`);
            const data = await res.json();
            setThisusername(data.username);
            setThisfirstname(data.firstname);
            setThismiddlename(data.middlename);
            setThislastname(data.lastname);
            setThisemail(data.email);
            setThisphone(data.phone);
            setThisrole(data.role);
            setThisbranch(data.branch_id);
            setModal2(!modal2)

        }

       
        

    }

    const updateUser = async()=>{
        if(userrole == 'Admin'){
            const res = await fetch('https://easyboxstoresapi.uuidesign.xyz/api/updateUser',{
                method:'POST',
                headers:{
                    "Content-Type":"application/json"
                },
                body:JSON.stringify({
                    selectedUser,thisFirstname,thisMiddlename,thisLastname,thisEmail,thisPhone,thisRole,thisBranch
                }),
                credentials:'include'
            })
    
            const data = await res.json();
            const{success} = data;
            if(success == true){
                toast.success('Changes saved')
                fetchBranches();
                setModal2(false)
            }
            else{
                toast.error('Something went wrong')
            }

        }
        else{
            toast.error('You do not have permissions to perform this action')
        }
        
    }

    const close=()=>{
        setModal2(false)
    }

    const deleteUser =async(e)=>{
        if(role !== 'Admin' || role !== 'Manager'){
            toast.error('You do not have rights to perform this action')
          }
        else{
            const id = e.target.value;
            const res = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/deleteUser?id=${id}`);
            const data = await res.json();
            const{success} = data;
            if(success == true){
                toast.success('User delete')
                fetchBranches();
            }
            else{
                toast.error('Something went wrong')
            }

        }

       
       
        
    }
  return (
    <div className='ordersContainer'>
    <ToastContainer />
          <Breadcrumbs title="Easybox" breadcrumbItem="Users" />
                <Button style={{marginBottom:'1%'}} color='success' onClick={toggle}>Add User</Button>
                <div className="card" style={{padding:'10px'}}>
                <p>Role: {userrole}</p>
                <div className="table-responsive">
            <Table striped bordered hover>

                <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Name</th>
                        <th scope="col">Branch</th>
                        <th scope="col">Phone</th>
                        <th scope="col">Email</th>
                        <th scope="col">Role</th>
                        <th scope="col">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {users.map((val,index)=>{
                        return(
                            <tr>
                                <td>{index+1}</td>
                                <td>{val.firstname} {val.lastname}</td>
                                <td>{val.branchName}</td>
                                <td>{val.phone}</td>
                                <td>{val.email}</td>
                                <td>{val.role}</td>
                                <td><button onClick={toggle2} className='tableButton' value={val.id} style={{color:'blue'}}>Edit</button><button className='tableButton' style={{color:'red'}} value={val.id} onClick={deleteUser}>Del</button></td>
                               
                            </tr>
                        )
                    })}
                </tbody>
            </Table>
            </div>
                </div>

    <Modal isOpen={modal} toggle={toggle} size='md'>
        <ModalHeader>Add user</ModalHeader>
        <div className="modalContainer">
        <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Username" onChange={(e)=>{setUsername(e.target.value)}}>
            <Form.Control  className='inputSearch' value={username}  type="text" placeholder="Username" />
        </FloatingLabel>
        <FloatingLabel className='formInput' controlId="floatingInputGrid" label="First name" onChange={(e)=>{setFirstname(e.target.value)}}>
            <Form.Control  className='inputSearch' value={firstname}  type="text" placeholder="First  name" />
        </FloatingLabel>
        <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Middle name" onChange={(e)=>{setMiddlename(e.target.value)}}>
            <Form.Control  className='inputSearch' value={middlename}  type="text" placeholder="Middle name" />
        </FloatingLabel>
        <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Last name" onChange={(e)=>{setLastname(e.target.value)}}>
            <Form.Control  className='inputSearch' value={lastname}  type="text" placeholder="Last name" />
        </FloatingLabel>
        <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Email" onChange={(e)=>{setUseremail(e.target.value)}}>
            <Form.Control  className='inputSearch' value={useremail}  type="email" placeholder="Email" />
        </FloatingLabel>
        <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Phone number" onChange={(e)=>{setPhone(e.target.value)}}>
            <Form.Control  className='inputSearch' value={phone}  type="text" placeholder="Phone number" />
        </FloatingLabel>
        <FloatingLabel className='formInput' controlId="floatingSelectGrid" label="Select role">
            <Form.Select
                className='inputSearch'
               
                onChange={(e) => setRole(e.target.value)}
            >
            <option selected disabled>Select role</option>
            <option value="Admin">Admin</option>
            <option value="Manager">Manager</option>
            <option value="Operations">Operations</option>
            </Form.Select>
        </FloatingLabel>
        <FloatingLabel className='formInput' controlId="floatingSelectGrid" label="Select branch">
            <Form.Select
                className='inputSearch'
               
                onChange={(e) => setBranch(e.target.value)}
            >
            <option selected disabled>Select branch</option>
            {branches.map((val)=>{
                return(
                    <option value={val.branch_id}>{val.branchName}</option>
                )
            })}
            </Form.Select>
        </FloatingLabel>

        <Button color='success' style={{marginTop:'2%'}} onClick={submitUser}>Submit</Button>
        </div>

    </Modal>



    <Modal isOpen={modal2} toggle={toggle2} size='md'>
        <ModalHeader>Edit {thisUsername}</ModalHeader>
        <div className="modalContainer">
        <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Username" >
            <Form.Control  className='inputSearch' value={thisUsername}  type="text" placeholder="Username" disabled />
        </FloatingLabel>
        <FloatingLabel className='formInput' controlId="floatingInputGrid" label="First name" onChange={(e)=>{setThisfirstname(e.target.value)}}>
            <Form.Control  className='inputSearch' value={thisFirstname}  type="text" placeholder="First  name" />
        </FloatingLabel>
        <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Middle name" onChange={(e)=>{setThismiddlename(e.target.value)}}>
            <Form.Control  className='inputSearch' value={thisMiddlename}  type="text" placeholder="Middle name" />
        </FloatingLabel>
        <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Last name" onChange={(e)=>{setThislastname(e.target.value)}}>
            <Form.Control  className='inputSearch' value={thisLastname}  type="text" placeholder="Last name" />
        </FloatingLabel>
        <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Email" onChange={(e)=>{setThisemail(e.target.value)}}>
            <Form.Control  className='inputSearch' value={thisEmail}  type="email" placeholder="Email" />
        </FloatingLabel>
        <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Phone number" onChange={(e)=>{setThisphone(e.target.value)}}>
            <Form.Control  className='inputSearch' value={thisPhone}  type="text" placeholder="Phone number" />
        </FloatingLabel>
        <FloatingLabel className='formInput' controlId="floatingSelectGrid" label="Select role">
            <Form.Select
                className='inputSearch'
               
                onChange={(e) => setThisrole(e.target.value)}
                
            >
            <option selected disabled>{thisRole}</option>
            <option value="Admin">Admin</option>
            <option value="Manager">Manager</option>
            <option value="Operations">Operations</option>
            </Form.Select>
        </FloatingLabel>
        <FloatingLabel className='formInput' controlId="floatingSelectGrid" label="Select branch">
            <Form.Select
                className='inputSearch'
               
                onChange={(e) => setThisbranch(e.target.value)}
            >
            <option selected disabled>{thisBranch}</option>
            {branches.map((val)=>{
                return(
                    <option value={val.branch_id}>{val.branchName}</option>
                )
            })}
            </Form.Select>
        </FloatingLabel>

        <Button color='success' style={{marginTop:'2%'}} onClick={updateUser}>Save changes</Button>
        <p onClick={close} style={{color:'red',textAlign:"right",cursor:'pointer'}} >Close</p>
        </div>

    </Modal>
                
    </div>
  )
}
